import * as CircleList from '../../constants/User/CircleList'

const initialState = {
  listLoading: false,
  ownList: '',
  joinedList: ''
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case CircleList.GET_MY_CIRCLE_LIST:
      return state;

    case CircleList.GET_MY_CIRCLE_LIST_RESULT:
      return Object.assign({}, state, {
        ownList: action.list
      });

    case CircleList.GET_MY_JOINED_CIRCLE_LIST:
      return state;
    
    case CircleList.GET_MY_JOINED_CIRCLE_LIST_RESULT:
      return Object.assign({}, state, {
        joinedList: action.list
      });
    
    case CircleList.CIRCLE_LOAD_START:
      return Object.assign({}, state, {
        listLoading: true
      });

    case CircleList.CIRCLE_LOAD_END:
      return Object.assign({}, state, {
        listLoading: false
      });
    
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/User/CircleList.js